module.exports = __webpack_public_path__ + "media/images/yellow_star_solid-25002e4d9da28ce410650cb5c6134760.svg";